export default "__VITE_ASSET__B5_Oo9hJ__"